import React from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { twMerge } from 'tailwind-merge';

interface AnalyticsColumnEmptyStateProps {
  icon: IconDefinition;
  title: string;
  buttonText: string;
  onClick: () => void;
  className?: string;
}

/**
 * Column-specific empty state component for Analytics tables
 * Shows a compact empty state with clickable button for a specific column
 */
const AnalyticsColumnEmptyState: React.FC<AnalyticsColumnEmptyStateProps> = ({
  icon,
  title,
  buttonText,
  onClick,
  className,
}) => {
  return (
    <div
      className={twMerge(
        'flex flex-col items-center justify-center text-center gap-3 p-4',
        className
      )}
      data-testid="analytics-column-empty-state"
    >
      <Icon icon={icon} size="xl" className="w-10 h-10 text-neutral-400" />
      <div className="flex flex-col gap-2">
        <h4 className="text-sm font-semibold text-neutral-700">{title}</h4>
        <button
          onClick={onClick}
          className="px-4 py-2 bg-white rounded-full border border-neutral-200 text-sm font-medium text-primary hover:bg-neutral-50
            transition-colors"
        >
          {buttonText}
        </button>
      </div>
    </div>
  );
};

export default AnalyticsColumnEmptyState;
